module.exports = __webpack_public_path__ + "img/2fe51649c48525a6b206df070f153004.png";